import { zRequiredString } from "@goodfill/domain-properties-zod-validators";
import { DefaultValues } from "react-hook-form";
import z from "zod";
import { zUsStateIsoCode, zRequiredZipCode, zCountryIsoCode } from "./zodTypes";

export const zAddressWithoutCountryScheme = z.object({
  street1: zRequiredString(),
  street2: z.string().optional(),
  city: zRequiredString(),
  state: zUsStateIsoCode,
  zipCode: zRequiredZipCode,
});

export type AddressWithoutCountryScheme = z.infer<typeof zAddressWithoutCountryScheme>;

export const zAddressWithCountryScheme = zAddressWithoutCountryScheme.extend({ country: zCountryIsoCode });

export type AddressWithCountryScheme = z.infer<typeof zAddressWithCountryScheme>;

export const defaultAddressWithoutCountryScheme: DefaultValues<AddressWithoutCountryScheme> = {
  street1: "",
  city: "",
  state: undefined,
  zipCode: "",
};
